// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Psalms",
  bookSlug: "psalms",
  chapter: 112,
  argument: "God is to be praised, for his regard to the poor and humble.",
  verses: [
    { n: 1, text: "Alleluia. Praise the Lord, ye children: praise ye the name of the Lord." },
    { n: 2, text: "Blessed be the name of the Lord, from henceforth now and for ever." },
    { n: 3, text: "From the rising of the sun, unto the going down of the same, the name of the Lord is worthy of praise." },
    { n: 4, text: "The Lord is high above all nations: and his glory above the heavens." },
    { n: 5, text: "Who is as the Lord, our God, who dwelleth on high: 6 and looketh down on the low things in heaven and in earth?" },
    { n: 7, text: "Raising up the needy from the earth, and lifting up the poor out of the dunghill:" },
    { n: 8, text: "That he may place him with princes, with the princes of his people." },
    { n: 9, text: "Who maketh a barren woman to dwell in a house, the joyful mother of children." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Alleluia. The Jews style this, and the five following psalms, \"the great Alleluia,\" which they sing after eating the paschal lamb. Eusebius adds, \"a psalm of Agg�us and Zacharias,\" as it seems to speak of the captives, who return thanks for their deliverance; (Isaias xlv. 6., &c.; Calmet) or David has left this model of thanksgiving for all. (Berthier) — Children. Hebrew, \"slaves.\" (Menochius) — The Greek and Latin may signify both. (Haydock) — He addresses the Levites, who were addicted to God's service, or the new converts, who were become docile like little children, (1 Peter ii. 2., and Psalm viii. 3.; Calmet) and in a word, (Haydock) all God's servants.", attribution: "Worthington" }
    ] },
    { verse: 3, notes: [
      { text: "Same. All the day long, (Calmet) or rather in all places. (Muis) (Malachias i. 10.)", attribution: "St. Chrysostom" }
    ] },
    { verse: 6, notes: [
      { text: "Earth. Providence watches over all, Psalm cxxxvii. 6. (Haydock) — With respect to God, even those who are in heaven are low.", attribution: "Worthington" }
    ] },
    { verse: 7, notes: [
      { text: "Poor. Jesus Christ and his servants, as well as Joseph, Mardochai, &c., 1 Kings ii. 8., and Luke i. 51.", attribution: "Calmet" }
    ] },
    { verse: 9, notes: [
      { text: "Children. Anna and Elizabeth, who were naturally barren, were blessed with what they so eagerly desired, by the divine power. (Haydock) — It may be understood of the Gentile world, after it had embraced the faith, (St. Jerome; Galatians iv. 17.; St. Chrysostom) or of the captives, (Isaias lvi. 1., and xlix. 21., and Psalm lxvii. 7.; Calmet) though Isaias may also refer to the Church. (Haydock) — Joseph was wonderfully advanced in glory, and Sara, Rebecca, &c., were made fruitful.", attribution: "Haydock" }
    ] },
  ],
};

export default chapter;
